export const calcPercentage = (init, end) => {
  const result = Math.trunc((parseInt(init, 10) * 100) / parseInt(end, 10))
  return `${result || 0}`
}
